import { render, staticRenderFns } from "./CreateCategoryStep.vue?vue&type=template&id=4f244aea&"
import script from "./CreateCategoryStep.vue?vue&type=script&lang=js&"
export * from "./CreateCategoryStep.vue?vue&type=script&lang=js&"
import style0 from "./CreateCategoryStep.vue?vue&type=style&index=0&id=4f244aea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports